/* as low as amount rendering */
console.log(breadProdLib);
var breadProductID;
var breadProductPrice;
var breadProductTitle;
var breadProductSKU;
var breadProductImage;
var breadProductURL;
$.each( breadProdLib, function( key, value ) {
    console.log(value.id);
    breadProductID = value.id;
    breadProductPrice = parseInt(value.price);
    breadProductTitle = value.title;
    breadProductSKU = value.sku;
    breadProductImage = value.image;
    breadProductURL = value.url;

   });
bread.asLowAs([
    {
        customTotal: breadProductPrice,
    id: breadProductID // optional

}
], function (data, err) {
    if (err) {
        console.error(err);
        return;
    }
    data.forEach(function (item) {
        console.log(item);
        const asLowAs = item.asLowAs;
        const el = document.getElementsByClassName("bread-as-low-as");
        console.log(el);
        $( ".bread-as-low-as" ).html('' + asLowAs.amount + ' <span id="financing-disclosure">*</span>');
        //el.innerHTML = 'As low as ' + asLowAs.amount + ' / Month <span id="financing-disclosure">*</span>';
    });
});
/* Prequalify button click */
var opts = {
    buttonId: 'bread-btn',
    actAsLabel: false,
    asLowAs: true,
    allowCheckout: false,
    items: [
        {
            name: breadProductTitle,
            price: breadProductPrice,
    sku: breadProductSKU,
    imageUrl: breadProductImage,
    detailUrl: breadProductURL,
    quantity: 1
}]
};
var elements = document.getElementsByClassName("bread-btn");

var myFunction = function() {
console.log("in function");
console.log()
    opts.done = function (err, tx_token) {
        if (err) {
            console.error("There was an error: " + err);
            return;
        }
        if (tx_token !== undefined) {
            console.log(tx_token);
            var i = document.createElement('input');
            i.type = 'hidden';
            i.name = 'token';
            i.value = tx_token;
            var f = document.createElement('form');
            f.action = '[REPLACEMEWITHSERVICEURL]';
            f.method = 'POST';
            f.appendChild(i);
            document.body.appendChild(f);
            f.submit();
        }
        return;
    };
    bread.showCheckout(opts);
};
for (var i = 0; i < elements.length; i++) {
elements[i].addEventListener('click', myFunction, false);
}

// document.getElementsByClassName('bread-btn').addEventListener('click', function (e) {
    
// });
//   bread.checkout(opts);